module.exports = __webpack_public_path__ + "img/arrow-right-circle-fill.f347b693.svg";